<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-form-group label-for="persentase-realisasi">
          <template #label>Persentase Realisasi <span class="text-danger">*</span></template>
          <b-input-group append="%">
            <b-form-input
              id="persentase-realisasi"
              :value="value.persentase_realisasi"
              type="number"
              min="0"
              max="100"
              step="0.01"
              @input="updateField('persentase_realisasi', $event)"
            />
          </b-input-group>
          <small v-if="fieldErrors.persentase_realisasi" class="text-danger">{{
            fieldErrors.persentase_realisasi
          }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label-for="kriteria-realisasi">
          <template #label>Kriteria <span class="text-danger">*</span></template>
          <b-form-select
            id="kriteria-realisasi"
            :value="value.kriteria"
            :options="kriteriaOptions"
            class="form-control"
            @change="updateField('kriteria', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label-for="kategori-realisasi">
          <template #label>Kategori <span class="text-danger">*</span></template>
          <b-form-select
            id="kategori-realisasi"
            :value="value.kategori"
            :options="kategoriOptions"
            class="form-control"
            @change="updateField('kategori', $event)"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label-for="luas-area-infrastruktur">
          <template #label>Luas Area Infrastruktur <span class="text-danger">*</span></template>
          <b-input-group append="ha">
            <b-form-input
              id="luas-area-infrastruktur"
              :value="value.luas_area_infrastruktur"
              type="number"
              min="0"
              step="0.01"
              @input="updateField('luas_area_infrastruktur', $event)"
            />
          </b-input-group>
          <small v-if="fieldErrors.luas_area_infrastruktur" class="text-danger">{{
            fieldErrors.luas_area_infrastruktur
          }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="persentase-area-infrastruktur">
          <template #label>Persentase Area Infrastruktur <span class="text-danger">*</span></template>
          <b-input-group append="%">
            <b-form-input
              id="persentase-area-infrastruktur"
              :value="value.persentase_area_infrastruktur"
              type="number"
              min="0"
              max="100"
              step="0.01"
              @input="updateField('persentase_area_infrastruktur', $event)"
            />
          </b-input-group>
          <small v-if="fieldErrors.persentase_area_infrastruktur" class="text-danger">{{
            fieldErrors.persentase_area_infrastruktur
          }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="luas-area-non-infrastruktur">
          <template #label>Luas Area Non-Infrastruktur <span class="text-danger">*</span></template>
          <b-input-group append="ha">
            <b-form-input
              id="luas-area-non-infrastruktur"
              :value="value.luas_area_non_infrastruktur"
              type="number"
              min="0"
              step="0.01"
              @input="updateField('luas_area_non_infrastruktur', $event)"
            />
          </b-input-group>
          <small v-if="fieldErrors.luas_area_non_infrastruktur" class="text-danger">{{
            fieldErrors.luas_area_non_infrastruktur
          }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="persentase-area-non-infrastruktur">
          <template #label>Persentase Area Non-Infrastruktur <span class="text-danger">*</span></template>
          <b-input-group append="%">
            <b-form-input
              id="persentase-area-non-infrastruktur"
              :value="value.persentase_area_non_infrastruktur"
              type="number"
              min="0"
              max="100"
              step="0.01"
              @input="updateField('persentase_area_non_infrastruktur', $event)"
            />
          </b-input-group>
          <small v-if="fieldErrors.persentase_area_non_infrastruktur" class="text-danger">{{
            fieldErrors.persentase_area_non_infrastruktur
          }}</small>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label-for="kriteria-subjek-hukum">
          <template #label>Kriteria Subjek Hukum <span class="text-danger">*</span></template>
          <b-form-select
            id="kriteria-subjek-hukum"
            :value="value.kriteria_subjek_hukum"
            :options="kriteriaOptions"
            class="form-control"
            @change="updateField('kriteria_subjek_hukum', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kategori-subjek-hukum">
          <template #label>Kategori Subjek Hukum <span class="text-danger">*</span></template>
          <b-form-select
            id="kategori-subjek-hukum"
            :value="value.kategori_subjek_hukum"
            :options="kategoriOptions"
            class="form-control"
            @change="updateField('kategori_subjek_hukum', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kriteria-persetujuan">
          <template #label>Kriteria Persetujuan <span class="text-danger">*</span></template>
          <b-form-select
            id="kriteria-persetujuan"
            :value="value.kriteria_persetujuan"
            :options="kriteriaOptions"
            class="form-control"
            @change="updateField('kriteria_persetujuan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kategori-persetujuan">
          <template #label>Kategori Persetujuan <span class="text-danger">*</span></template>
          <b-form-select
            id="kategori-persetujuan"
            :value="value.kategori_persetujuan"
            :options="kategoriOptions"
            class="form-control"
            @change="updateField('kategori_persetujuan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kriteria-kewajiban-kkprl">
          <template #label>Kriteria Kewajiban KKPRL <span class="text-danger">*</span></template>
          <b-form-select
            id="kriteria-kewajiban-kkprl"
            :value="value.kriteria_kewajiban_kkprl"
            :options="kewajibanOptions"
            class="form-control"
            @change="updateField('kriteria_kewajiban_kkprl', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kategori-kewajiban-kkprl">
          <template #label>Kategori Kewajiban KKPRL <span class="text-danger">*</span></template>
          <b-form-select
            id="kategori-kewajiban-kkprl"
            :value="value.kategori_kewajiban_kkprl"
            :options="kategoriOptions"
            class="form-control"
            @change="updateField('kategori_kewajiban_kkprl', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label-for="hasil-penilaian-finalisasi">
      <template #label>Hasil Penilaian <span class="text-danger">*</span></template>
      <div class="hasil-penilaian-button-group">
        <b-form-radio-group
          id="hasil-penilaian-finalisasi"
          :checked="value.hasil_penilaian"
          :options="hasilPenilaianOptions"
          name="hasil-penilaian-finalisasi"
          buttons
          button-variant="outline-primary"
          @input="updateField('hasil_penilaian', $event)"
        />
      </div>
    </b-form-group>

    <b-form-group label-for="catatan-finalisasi">
      <template #label>Catatan <span class="text-danger">*</span></template>
      <ckeditor
        id="catatan-finalisasi"
        :editor="wygEditor"
        :value="value.catatan || ''"
        @input="updateField('catatan', $event)"
      />
    </b-form-group>

    <section class="mb-4">
      <h5 class="mb-3">Tim Penilai <span class="text-danger">*</span></h5>

      <v-select
        id="tim-penilai"
        :value="value.tim_penilai"
        :options="timPenilaiOptions"
        :reduce="(user) => user.id"
        label="nama"
        multiple
        placeholder="Pilih Tim Penilai"
        :disabled="isLoadingTimPenilai"
        @input="updateField('tim_penilai', $event)"
      />

      <small v-if="isLoadingTimPenilai" class="text-muted d-block mt-1">Memuat daftar tim penilai...</small>
      <small v-else-if="timPenilaiError" class="text-danger d-block mt-1">{{ timPenilaiError }}</small>
    </section>

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button type="button" variant="outline-primary" class="mr-2 mb-2" @click="showPreviewModal = true">
          <i class="fa fa-eye"></i> Preview Hasil Penilaian
        </b-button>
        <b-button variant="success" class="mr-2 mb-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="success" class="mb-2" @click="$emit('submit')">Submit Penilaian</b-button>
      </div>
    </div>

    <document-preview-modal v-model="showPreviewModal" title="Preview Hasil Penilaian" />
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import DocumentPreviewModal from '@/components/DocumentPreviewModal/DocumentPreviewModal.vue'
import api from '@/services/api'

export default {
  name: 'FormFinalisasiPusat',
  components: { vSelect, DocumentPreviewModal },
  props: {
    value: {
      type: Object,
      default: () => ({
        persentase_realisasi: '',
        kriteria: '',
        kategori: '',
        luas_area_infrastruktur: '',
        persentase_area_infrastruktur: '',
        luas_area_non_infrastruktur: '',
        persentase_area_non_infrastruktur: '',
        kriteria_subjek_hukum: '',
        kategori_subjek_hukum: '',
        kriteria_persetujuan: '',
        kategori_persetujuan: '',
        kriteria_kewajiban_kkprl: '',
        kategori_kewajiban_kkprl: '',
        hasil_penilaian: '',
        catatan: '',
        tim_penilai: [],
      }),
    },
  },
  data() {
    return {
      kriteriaOptions: [
        { value: '', text: 'Pilih Kriteria' },
        { value: 'Sesuai', text: 'Sesuai' },
        { value: 'Tidak Sesuai', text: 'Tidak Sesuai' },
      ],
      kategoriOptions: [
        { value: '', text: 'Pilih Kategori' },
        { value: 'Taat', text: 'Taat' },
        { value: 'Tidak Taat', text: 'Tidak Taat' },
      ],
      kewajibanOptions: [
        { value: '', text: 'Pilih Kriteria Kewajiban KKPRL' },
        { value: 'Dilaksanakan', text: 'Dilaksanakan' },
        { value: 'Tidak Dilaksanakan', text: 'Tidak Dilaksanakan' },
      ],
      hasilPenilaianOptions: [
        { value: 'Taat', text: 'Taat' },
        { value: 'Taat dengan Catatan', text: 'Taat dengan Catatan' },
        { value: 'Tidak Taat', text: 'Tidak Taat' },
      ],
      wygEditor: ClassicEditor,
      timPenilaiOptions: [],
      isLoadingTimPenilai: false,
      timPenilaiError: '',
      showPreviewModal: false,
    }
  },
  mounted() {
    this.getTimPenilai()
  },
  computed: {
    fieldErrors() {
      return {
        persentase_realisasi: this.numericFieldError('persentase_realisasi', true),
        luas_area_infrastruktur: this.numericFieldError('luas_area_infrastruktur'),
        persentase_area_infrastruktur: this.numericFieldError('persentase_area_infrastruktur', true),
        luas_area_non_infrastruktur: this.numericFieldError('luas_area_non_infrastruktur'),
        persentase_area_non_infrastruktur: this.numericFieldError('persentase_area_non_infrastruktur', true),
      }
    },
  },
  methods: {
    numericFieldError(field, isPercentage = false) {
      const value = String(
        this.value[field] === undefined || this.value[field] === null ? '' : this.value[field],
      ).trim()
      if (!value) return ''
      if (!/^\d+(\.\d{1,2})?$/.test(value)) return 'Masukkan angka nonnegatif dengan maksimal dua angka desimal.'
      if (isPercentage && Number(value) > 100) return 'Persentase harus berada di antara 0 dan 100.'
      return ''
    },
    updateField(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
    async getTimPenilai() {
      this.isLoadingTimPenilai = true
      this.timPenilaiError = ''
      try {
        const response = await api.get('api/user?filter=roles,contains,Penilai;nama_upt,=,PUSAT&limit=0')
        this.timPenilaiOptions = response.data?.data || []
      } catch (error) {
        this.timPenilaiError = 'Daftar Tim Penilai gagal dimuat.'
      } finally {
        this.isLoadingTimPenilai = false
      }
    },
  },
}
</script>

<style scoped>
.hasil-penilaian-button-group {
  overflow-x: auto;
}
</style>
